import { getAbility } from '@cast/infrastructure-abilities';

export const CAN_VIEW_SECURITY = () =>
  !!getAbility()?.canOneOf?.('view', [
    'OrganizationSecurityAttackPaths',
    'OrganizationSecurityCompliance',
    'OrganizationSecurityIntegrations',
    'OrganizationSecurityRuntime',
    'OrganizationSecurityNodeRotation',
    'OrganizationSecurityVulnerabilities',
    'OrganizationSecuritySettings',
    'OrganizationSecurityWorkloads',
  ]);

// Query parameters to remove on app initialization (e.g., Auth0 email verification params)
// Note: 'code' param is intentionally NOT auto-removed to support OAuth flows
// (e.g., Slack OAuth). OAuth integrations must manually clean 'code' after processing.
export const PARAMS_TO_REMOVE = [
  'supportSignUp',
  'supportForgotPassword',
  'email',
  'message',
  'success',
];
